import { createReduxAsyncThunk } from 'shared/utils';

import dataSources from 'dataSources';

import { STATIONS_STATE } from '../../constants';

import { FavouriteStation } from '../../types';

export const deleteFavouriteStations = createReduxAsyncThunk<
  { favouriteStationCodes: FavouriteStation['stationCode'][] },
  FavouriteStation['stationCode'][]
>(
  `${STATIONS_STATE}/deleteFavouriteStations`,
  async (stationCodes) => {
    await dataSources.stationsWithPrices.deleteFavouriteStations(stationCodes);
    return { favouriteStationCodes: stationCodes };
  }
);
